import type { CoreUserDocument } from '@flecto/types'

import { api } from '../../../services/api'

export async function createCloudflareDocument(
  file: File,
  options?: { signal?: AbortSignal }
): Promise<CoreUserDocument> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('name', file.name)
  const { signal } = options || {}

  const response = await api.post('/api/documents', formData, {
    baseURL: '/',
    signal,
  })

  return response.data.data as CoreUserDocument
}
